import fileSys from "../../../fileoprators/fileSystem";
// const tearHeightApi = window.require(fileSys.getUtilPath('tearApi.node'))
const DryEyeApiNode = {
  /**
   * 泪河高度计算
   * filepath: 源文件路径
   * arrX:算法给出的X坐标数组
   * arrY:算法给出的Y坐标数组
   * len:数组长度
   * trendImagePath: 趋势图的生成全路径
   * printImagePath：打印图的生成全路径
   */
  Nibut: (filepath) => {
    return {
      result: 0
    };
  },
  Meibomian() {
    return [];
  },
  TearHeight: (filepath, printImagePath) => {
    // let tearRes = tearHeightApi.TearHeight(filepath, fileSys.getMediaPath())
    // console.log('tearRes', tearRes)
    let arrX = [];
    let arrY = [];
    let len = 1500;
    for (let id = 0; id < len; id++) {
      arrX[id] = id;
      arrY[id] = Math.random() * 1024;
    }

    fileSys.copyFile(fileSys.getMockPath("test.jpg"), fileSys.getMediaPath("trend.jpg"));
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), fileSys.getMediaPath("print.jpg"));
    return {
      tearArrayX: [],
      tearArrayY: []
    };
  },
  MeibomianAuto: (filepath, filepathEnhance, filepathContour, filepathPrint, percent, loss) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathEnhance);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathContour);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathPrint);
    percent[0] = 30;
    loss[0] = 40;
    return {
      result: 0
    };
  },
  MeibomianManual: (
    filepath,
    filepathEnhance,
    filepathContour,
    filepathPrint,
    points,
    percent,
    loss
  ) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathEnhance);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathContour);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathPrint);
    percent[0] = 30;
    loss[0] = 40;
    return {
      result: 0
    };
  },
  EyeRedness: (
    filepath,
    filepathEnhance,
    filepathBulbar,
    filepathCiliary,
    filepathprint,
    congestionBulbarNasal,
    congestionBulbarTemp,
    congestionCiliaryNasal,
    congestionCiliaryTemp
  ) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathEnhance);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathBulbar);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathCiliary);
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathprint);
    return {
      result: 0
    };
  },
  EyelidEdge: (filepath, filepathprint) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepathprint);
    return {
      result: 0
    };
  }
  // RedeyeAnalysis520: (filepath,, mnnPath) => { }
};
export default DryEyeApiNode;



// WEBPACK FOOTER //
// ./src/dryeye/js/algorithm/DryEyeApiNode.js